import { useCallback, useRef, useMemo, } from 'react';
import clsx from 'clsx';
import Depot from '../../../_shared/depot';
import typeSizes from '../../../Typography/shared/typeSizes/typeSizes';
import colors from '../../../Typography/shared/colours/colours';
import { setMultipleRefs } from '../../../_shared/helpers';
import * as styles from './style.module.css';
import fontWeights from '../../../Typography/shared/fontWeights/fontWeights';
export const allowedTypeSizes = ['large', 'body', 'small'];
const NumberWithoutRef = ({ typeStyle = 'body', fontWeight = 'regular', innerRef, value, min, max, disabled = false, disableNumberEntry = false, className, step, ...commonProps }) => {
    const numberRef = useRef(null);
    const numberClasses = clsx(styles.number, colors.base, fontWeights[fontWeight], typeSizes[typeStyle], className);
    // widths of number inputs are kinda old skool... they are determined by `size` but `size` :`width` ratio is widely different by browser
    // `size` attr is good for chrome, but is a bit crazy in firefox, hense dynamic width
    const size = useMemo(() => max.toString().length, [max]);
    const style = useMemo(() => ({
        '--dp-number-default-width': `${size * 0.8}em`, // using css var so it is easier to override `width` with className if required
    }), [size]);
    const handleKeyDown = useCallback((e) => {
        if (!disableNumberEntry)
            return;
        if (!isNaN(parseFloat(e.key))) {
            e.preventDefault();
        }
    }, [disableNumberEntry]);
    return Depot.createElement('input', {
        type: 'number',
        innerRef: setMultipleRefs([innerRef, numberRef]),
        className: numberClasses,
        value,
        min,
        max,
        step,
        size,
        disabled,
        onKeyDown: handleKeyDown,
        dangerouslySetStyle: style,
        ...commonProps,
    });
};
const Number = Depot.withRef(NumberWithoutRef);
Number.displayName = 'Number';
export default Number;
//# sourceMappingURL=index.js.map